export const PrescriptionSourceFullTypes = Object.freeze({
  0: { label: "Not specified", color: "#808080" },
  1: { label: "Manual", color: "#999999" },
  2: { label: "Eps R1", color: "#b228ce" },
  3: { label: "Barcode", color: "#e74c3c" },
  4: { label: "Barcode", color: "#e74c3c" },
  5: { label: "Eps Scotland", color: "#0072ff" },
  6: { label: "Scanned RX", color: "#f5a623" },
  7: { label: "Primo", color: "#16a085" },
  8: { label: "Central", color: "#27ae60" },
  9: { label: "Eps R2", color: "#d00218" },
  10: { label: "Private Rx", color: "#d35400" },
  11: { label: "Power Mail", color: "#8e44ad" },
});
